

export const mapProductGeneralGetAllValues = (productGeneral) => {
  if (!productGeneral) return {};

  return {
    id: productGeneral.exportProductGeneralId || "",
    exportProductId: productGeneral.exportProductId || "",
    EximCode: productGeneral.exportProductGeneralEximCode || "",
    NFEICategory: productGeneral.exportProductGeneralNFEICategory || "",
    STRCode: productGeneral.exportProductGeneralSTRCode || "",
    EndUse: productGeneral.exportProductGeneralEndUse || "",
    EndUseId: productGeneral.exportProductGeneralEndUseId || "",
    PTAFTAInfo: productGeneral.exportProductGeneralPTAFTAInfo || "",
    PTAFTAInfoId: productGeneral.exportProductGeneralPTAFTAInfoId || "",
    QuantityUnit: productGeneral.exportProductGeneralQuantityUnit || "",
    QuantityUnitId: productGeneral.exportProductGeneralQuantityUnitId || "",
    AlternateQtyValue: productGeneral.exportProductGeneralAlternateQtyValue || "",
    AlternateQtyValueId: productGeneral.exportProductGeneralAlternateQtyValueId || "",
    OriginDistrict: productGeneral.exportProductGeneralOriginDistrict || "",
    OriginDistrictId: productGeneral.exportProductGeneralOriginDistrictId || "",
    OriginState: productGeneral.exportProductGeneralOriginState || "",
    MaterialCode: productGeneral.exportProductGeneralMaterialCode || "",
    Formulation: productGeneral.exportProductGeneralFormulation || "",
    MedicinalPlant: productGeneral.exportProductGeneralMedicinalPlant || "",
    SurfaceMaterialInContact: productGeneral.exportProductGeneralSurfaceMaterialInContact || "",
    LabGrownDiamond: productGeneral.exportProductGeneralLabGrownDiamond || "",
    Currency: productGeneral.exportProductGeneralCurrency || "",
    CalcMethod: productGeneral.exportProductGeneralCalcMethod || "",
    CalcAmount: productGeneral.exportProductGeneralCalcAmount || 0,
    PMVPerUnit: productGeneral.exportProductGeneralPMVPerUnit || 0,
    PMVPerUnitCurrencyValue: productGeneral.exportProductGeneralPMVPerUnitCurrencyValue || "",
    Value: productGeneral.exportProductGeneralValue || 0,
    TotalPMV: productGeneral.exportProductGeneralTotalPMV || 0,
    TotalPMVCurrencyValue: productGeneral.exportProductGeneralTotalPMVCurrencyValue || "",
    IGSTPymtStatus: productGeneral.exportProductGeneralIGSTPymtStatus || "",
    IGSTRate: productGeneral.exportProductGeneralIGSTRate || 0,
    CompCess: productGeneral.exportProductGeneralCompCess || 0,
    TaxableValueINR: productGeneral.exportProductGeneralTaxableValueINR || 0,
    IGSTAmountINR: productGeneral.exportProductGeneralIGSTAmountINR || 0,
    CompCessAmountINR: productGeneral.exportProductGeneralCompCessAmountINR || 0,
    RODTEPClaim: productGeneral.exportProductGeneralRODTEPClaim || "",
    RODTEPAmountINR: productGeneral.exportProductGeneralRODTEPAmountINR || 0,
    RatePercent: productGeneral.exportProductGeneralRatePercent || 0,
    CapValue: productGeneral.exportProductGeneralCapValue || 0,
    CapValuePerUnit: productGeneral.exportProductGeneralCapValuePerUnit || 0,
    CapValuePerUnitValue: productGeneral.exportProductGeneralCapValuePerUnitValue || 0,
    exportProductGeneralRewardItem: productGeneral.exportProductGeneralRewardItem ,
  };
};

export const mapProductGeneral = (data) => {
  return {
   // exportProductId: data.exportProductId || "",
   exportProductGeneralEximCode: data.EximCode || "",
    exportProductGeneralNFEICategory: data.NFEICategory || "",
    exportProductGeneralRewardItem: data.exportProductGeneralRewardItem,
    exportProductGeneralSTRCode: data.STRCode || "",
    exportProductGeneralEndUse: data.exportProductGeneralEndUse || "",
    exportProductGeneralOriginDistrict: data.OriginDistrict || "",
    exportProductGeneralOriginState: data.OriginState || "",
    exportProductGeneralPTAFTAInfo: data.PTAFTAinfo || "",

    // ✅ Correct order (fix Postman issue)
    exportProductGeneralAlternateQtyUnit: data.AlternateQty || "",   
    exportProductGeneralAlternateQtyValue: data.AlternateQtyUnit || "",

    exportProductGeneralMaterialCode: data.MaterialCode || "",
    exportProductGeneralMedicinalPlant: data.MedicinalPlant || "",
    exportProductGeneralFormulation: data.Formulation || "",
    exportProductGeneralSurfaceMaterialInContact: data.SurfaceMaterialInContact || "",
    exportProductGeneralLabGrownDiamond: data.LabGrownDiamond || "",
    exportProductGeneralCurrency: data.Currency || "",
    exportProductGeneralCalcMethod: data.CalcMethod || "",
    exportProductGeneralCalcAmount: data.CalcAmount || "",
    exportProductGeneralPMVPerUnit: data.PMVPerUnit || "",
    exportProductGeneralValue: data.Value || "",
    exportProductGeneralPMVPerUnitCurrencyValue: data.PMVUnit || "",
    exportProductGeneralTotalPMV: data.TotalPMV || "",
    exportProductGeneralTotalPMVCurrencyValue: data.TotalPMVCurrencyValue || "",
    exportProductGeneralIGSTPymtStatus: data.IGSTPymtStatus || "",
    exportProductGeneralIGSTRate: data.IGSTRate || "",
    exportProductGeneralCompCess: data.CompCess || "",
    exportProductGeneralTaxableValueINR: data.TaxableValue || "",
    exportProductGeneralIGSTAmountINR: data.IGSTAmount || "",
    exportProductGeneralCompCessAmountINR: data.CompCessAmount || "",
    exportProductGeneralRODTEPClaim: data.RODTEPClaim || "",
    exportProductGeneralQuantityValue: data.Quantity || "",
    exportProductGeneralQuantityUnit: data.QuantityUnit || "",
    exportProductGeneralRatePercent: data.Rate || "",
    exportProductGeneralCapValue: data.CapValue || "",
    exportProductGeneralCapValuePerUnit: data.CapValuePerUnit || "",
    exportProductGeneralCapValuePerUnitValue: data.CapValuePerUnitValue || "",
    exportProductGeneralRODTEPAmountINR: data.RODTEPAmount || "",
  };
};

export const mapInvoiceDetails = (resp) => ({
  id: {id : resp.exportInvoiceId , name : resp.exportInvoiceNumber} || "",
  name: resp.exportInvoiceNumber || "",
});
